<nz-spin [nzSpinning]="isLoading | async" [nzSize]="'small'">
  <nz-avatar *ngIf="!(isLoading | async)" [nzSrc]="src" [nzIcon]="icon" [nzShape]="shape || defaultShape"
    [nzSize]="size || defaultSize" [nzText]="text" [ngClass]="{
      'full-width': fullWidth,
      'full-height': fullHeight,
      'center-content': centerImage
    }" [ngStyle]="{
      'max-height': maxHeight ? maxHeight : 'unset',
      color: color ? color : defaultColor,
      'background-color': background ? background : defaultBackground
    }" />
</nz-spin>
